import React from 'react';
import { Check } from 'lucide-react';
import './CampaignProgress.css';

const CampaignProgress = ({ currentStep, steps, onStepClick }) => {
    return (
        <div className="campaign-progress">
            <div className="progress-steps">
                {steps.map((step, index) => (
                    <React.Fragment key={step.number}>
                        <div
                            className="progress-step"
                            onClick={() => onStepClick(step.number)}
                        >
                            <div className={`progress-circle 
                ${currentStep > step.number ? 'completed' : ''}
                ${currentStep === step.number ? 'active' : ''}
              `}>
                                {currentStep > step.number ? <Check size={20} /> : step.number}
                            </div>
                            <span className={`progress-label 
                ${currentStep >= step.number ? 'active' : ''}
              `}>
                                {step.label}
                            </span>
                        </div>
                        {index < steps.length - 1 && (
                            <div className={`progress-line 
                ${currentStep > step.number ? 'filled' : ''}
              `} />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default CampaignProgress;